import language from "./mixins/language";
export default {
  name: "privacy-policy",
  mixins: [language],
  methods: {
    afterCreated: function afterCreated() {
      document.title = this.$t('privacy_policy.title'); // 标题国际化
    },
    scrollToSection: function scrollToSection(id) {
      var idName = 'section' + id;
      var element = document.getElementById(idName);

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }
};